import React from 'react';

const SectionImage = ({ src, alt }) => (
  <img src={src} alt={alt} className="integrationsPortal-section-img" />
);

export default SectionImage;
